import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { HelperService } from 'src/app/services/helper.service';
import { ModalController, NavController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-order-history-detail',
  templateUrl: './order-history-detail.page.html',
  styleUrls: ['./order-history-detail.page.scss'],
})
export class OrderHistoryDetailPage implements OnInit {
  orderDetails: any;
  userId: any;
  modelData: any;
  index: any;
  pDate: any;
  tDate: any;
  cDate: any;
  rDays: any;
  spotCoins: any;
  msg: any;
  a: boolean = false;
  hoursDifference: any;
  btnDisabled: boolean;
  orderCancel: boolean=false;
  constructor(private routerActivate: ActivatedRoute,
    private router: Router,
    public modalController: ModalController,
    private toast: HelperService,
    private service: StoreService,
    private navController: NavController,
    private toastr: ToastService,
    ) { }
  ngOnInit() {
    this.routerActivate.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
        this.orderDetails = this.router.getCurrentNavigation().extras.state.cat;
         localStorage.setItem('deliveryBoyId', this.orderDetails.deliveryBoyId)
        console.log("order history", this.orderDetails)
        console.log("dateTime", this.orderDetails.orderDate)
        this.getTime()
      }
    })
  }
  getTime() {
    this.hoursDifference = new Date().getTime() - new Date(this.orderDetails.orderDate).getTime()
    console.log("***********", this.hoursDifference / (1000 * 60 * 60))
  }
  goBack() {
    this.navController.back();
  }

  notifications() {
    this.router.navigate(['/'])
  }
  trackLocation(orderID: any) {
    let navigationParams: NavigationExtras = { state: { orderID } };
    this.router.navigate(['/delboylocation'], navigationParams);
  }
  getStatus(status) {
    if (status == -1)
      return 'Payment Cancelled'
    if (status == 0)
      return 'Placed'
    if (status == 1)
      return 'Store Accepted Order'
    if (status == 2)
      return 'Store Rejected Order'
    if (status == 3)
      return 'Order Packed'
    if (status == 4)
      return 'Delivery Rejected'
    if (status == 5)
      return 'Order Delivered'
    if (status == 6)
      return 'Customer Declined'
    if (status == 7)
      return 'Cancelled'
    if (status == 8)
      return 'Return/Refund Request'
  }
  getStatusClass(status) {
    if (status == -1 || status == 2 || status == 4 || status == 6 || status == 7){
      this.orderCancel = true
      return 'cancelled'
    }
    else if (status == 8)
      return 'primary'
    else{
      this.orderCancel = false
      return 'placed'
    }
  }
  
  onClick(id: any) {
    console.log(id)
    this.router.navigate(['./request-cancel/' + id])
  }
  handleMissingImage($event) {
    console.log($event)
    console.log("hello error");
    ($event.target as HTMLImageElement).style.display = 'none'
    this.a = true;
  }
  parseInt(str) {
    return parseInt(str);
  }
 
  productDetail1(productItem: any) {
    console.log("hello hi ", productItem)
    this.router.navigate(['./product-detail/' + productItem.productId])
  }
  cancelOrderBtn(orderID, productId, paymentMode, productName, purchaseAmount) {
    if (this.hoursDifference / (1000 * 60 * 60) > 2) {
      this.btnDisabled = false;
      this.toastr.presentToast("Order can't be cancelled after 2 hours")
    } else {
      console.log("&&&&&&&&", orderID, productId)
      let navigationParams: NavigationExtras = { state: { orderId: orderID, productId: productId, paymentMode: paymentMode, productName: productName, purchaseAmount: purchaseAmount } };
      this.router.navigate(['/request-cancel'], navigationParams);
    }

  }
  generateInvoiceBtn(orderID, orderDate, productId, paymentMode, productName, purchaseAmount,quantity,deliveryfees,price,shippingAddress) {
    // let navigationParams: NavigationExtras = { state: { orderId: orderID, orderDate: orderDate, productId: productId, paymentMode: paymentMode, productName: productName, purchaseAmount: purchaseAmount,quantity:quantity,deliveryfees:deliveryfees,price:price,shippingAddress:shippingAddress } };
    // this.router.navigate(['/invoice'], navigationParams);
    // this.service.downloadInvoice(orderID);
    let options = {
      documentSize: 'A4',
      type: 'share',
      // landscape: 'portrait',
      fileName: 'Order-Invoice.pdf'
    };
    // this.pdfGenerator.fromURL("http://localhost:3000/downloadInvoice",options)
    //   .then((base64) => {
    //     console.log('OK', base64);
    //   }).catch((error) => {
    //     console.log('error', error);
    //   });
  }
}